import * as systemTokens from './system_tokens';

export const themeTokens = {
  text: {
    text: systemTokens.neutral_800,
    subtle: systemTokens.neutral_400,
    interactiveHovered: systemTokens.neutral_400,
    placeholder: systemTokens.neutral_400,
    inverse: systemTokens.neutral_alt_50,
    link: systemTokens.info_600,
    linkHovered: systemTokens.info_700,
    onPrimary: systemTokens.neutral_alt_50,
    onSecondary: systemTokens.primary_500,
    onAccent: systemTokens.accent_900,
    onDiscovery: systemTokens.discovery_800,
    disabled: systemTokens.neutral_400,
    positive: systemTokens.positive_500,
    negative: systemTokens.negative_500,
    hyperlink: systemTokens.info_600,
  },
  icon: {
    icon: systemTokens.neutral_800,
    subtle: systemTokens.neutral_400,
    interactiveHovered: systemTokens.neutral_400,
    inverse: systemTokens.neutral_alt_50,
    link: systemTokens.info_600,
    linkHovered: systemTokens.info_700,
    onPrimary: systemTokens.neutral_alt_50,
    onSecondary: systemTokens.primary_500,
    onAccent: systemTokens.accent_900,
    onDiscovery: systemTokens.discovery_800,
    onNav: systemTokens.surfing_50,
    onNavSelected: systemTokens.surfing_500,
    info: systemTokens.info_500,
    positive: systemTokens.positive_500,
    negative: systemTokens.negative_500,
    warning: systemTokens.warning_800,
    disabled: systemTokens.neutral_400,
    accent: systemTokens.accent_600,
  },
  bg: {
    app: systemTokens.neutral_alt_50,
    surfaceRecessed: systemTokens.neutral_alt_200,
    surface: systemTokens.neutral_alt_50,
    input: systemTokens.neutral_alt_50,
    surfaceRaised: systemTokens.neutral_alt_100,
    surfaceHovered: systemTokens.neutral_alt_300,
    surfacePressed: systemTokens.neutral_alt_500,
    surfaceShade: systemTokens.neutral_800,
    surfaceSelected: systemTokens.accent_50,
    disabled: systemTokens.neutral_alt_200,
    primary: systemTokens.primary_500,
    primaryHovered: systemTokens.primary_300,
    primaryPressed: systemTokens.primary_400,
    secondary: systemTokens.neutral_alt_500,
    secondaryActive: systemTokens.neutral_alt_700,
    secondaryHovered: systemTokens.neutral_alt_600,
    secondaryPressed: systemTokens.negative_700,
    accent: systemTokens.accent_600,
    accentTint: systemTokens.accent_50,
    accentSubtle: systemTokens.accent_100,
    accentHovered: systemTokens.accent_200,
    accentPressed: systemTokens.accent_300,
    accentSelected: systemTokens.accent_100,
    info: systemTokens.info_50,
    infoIntense: systemTokens.info_200,
    positive: systemTokens.positive_50,
    positiveIntense: systemTokens.positive_200,
    negative: systemTokens.negative_50,
    negativeIntense: systemTokens.negative_200,
    warning: systemTokens.warning_100,
    warningIntense: systemTokens.warning_200,
    discovery: systemTokens.discovery_50,
    discoveryIntense: systemTokens.discovery_100,
    discoveryHovered: systemTokens.discovery_100,
    discoveryPressed: systemTokens.discovery_200,
    nav: systemTokens.surfing_500,
    navHovered: systemTokens.surfing_700,
    navPressed: systemTokens.surfing_800,
    navInverseSelected: systemTokens.surfing_50,
    navInverseHovered: systemTokens.surfing_100,
    navInversePressed: systemTokens.surfing_200,
  },
  border: {
    border: systemTokens.neutral_100,
    input: systemTokens.neutral_100,
    subtle: systemTokens.neutral_50,
    inverse: systemTokens.neutral_alt_50,
    btnOutlined: systemTokens.neutral_800,
    shade: systemTokens.neutral_800,
    selected: systemTokens.accent_900,
    focus: '#0065FF' as const, // currently there is no system token for this color
    focusAlt: systemTokens.neutral_alt_50,
    disabled: systemTokens.neutral_alt_100,
    accent: systemTokens.accent_600,
    discovery: systemTokens.discovery_800,
    negative: systemTokens.negative_500,
    positive: systemTokens.positive_500,
    warning: systemTokens.warning_700,
  },
};
